import { cloneDeep } from 'lodash';
import { RouteConfig } from 'react-router-config';

import STORE from '@/store';

const ADMIN_ROUTE_PREFIX: string = '/admin/:lv1product/:lv2product/:lv3product';
const APP_ROUTE_PREFIX: string = '/:app';
type RecordPageRouteHandler = (c: RouteConfig) => RouteConfig;

enum PageRouteType {
  ROOT = 'root',
  OPERATE = 'operate',
  AI_SERVANT = 'aiServant',
  SMART_CONSTRUCTION = 'smartConstruction',
  AI_KNOWLEDGE = 'aiKnowledge',
  SATISFACTION = 'satisfaction',
  STATISTICS = 'statistics',
  CONFIG = 'config',
  SYSTEM = 'system',
  FAQ_MANAGEMENT = 'faq-layout',
  INSIGHT = 'insight',
  EXPERIMENT = 'experiment',
  EXPERIENCE = 'experience',
  OPERATION_MGT = 'operationMgt',
}

const addRoutePrefix = (path: string) =>
  `/admin/${STORE.productId}/${STORE.businessId}/${STORE.appId}/${path}`;

/**
 * 根据产品 ID 构建完整路由路径
 * @param path 路由路径（如 'overview', 'operate/aiseeList'）
 * @param productIds 产品 ID 对象，如果不提供则使用 store 中的值
 * @returns 完整的路由路径
 */
const buildRoutePath = (
  path: string,
  productIds?: {
    lv1Id: string;
    lv2Id: string;
    lv3Id: string;
  }
) => {
  if (productIds) {
    return `/admin/${productIds.lv1Id}/${productIds.lv2Id}/${productIds.lv3Id}/${path}`;
  }
  return addRoutePrefix(path);
};

const routeHandlerRecord: Record<PageRouteType, RecordPageRouteHandler> = {
  [PageRouteType.AI_SERVANT]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.SMART_CONSTRUCTION]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.ROOT]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.OPERATE]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.AI_KNOWLEDGE]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.SATISFACTION]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.STATISTICS]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.CONFIG]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.SYSTEM]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.FAQ_MANAGEMENT]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.INSIGHT]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.EXPERIMENT]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.EXPERIENCE]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
  [PageRouteType.OPERATION_MGT]: (config) => {
    config.path = `${ADMIN_ROUTE_PREFIX}${APP_ROUTE_PREFIX}${config.path}`;
    return config;
  },
};

const routePostProc = (type: PageRouteType, routes: RouteConfig[]) => {
  const list = cloneDeep(routes);
  const routeHandler = routeHandlerRecord[type];
  if (routeHandler) {
    return list.map((route) => routeHandler(route));
  }
  return list;
};

export { addRoutePrefix, buildRoutePath, PageRouteType, routePostProc };
